<template>
  <div class="text-ellipsis">
      <text-clamp :max-lines="rows" :text="text">
        <template #after="{ toggle,expanded, clamped }">
            <span
                @click="toggle"
                class="expand-collapse"
            >
                {{ expanded? collapseText : expandText }}
            </span>
        </template>
      </text-clamp>
  </div>
</template>

<script lang="ts">
import TextClamp from 'vue3-text-clamp';
export default {
name: "TqTextEllipsis",
components: {
  TextClamp
},
props: {
  text: {
    type: String,
    default: ""
  },
  rows: {
    type: Number,
    default: 1
  },
  expandText: {
    type: String,
    default: "展开"
  },
  collapseText: {
    type: String,
    default: "收起"
  }
},
data() {
  return {
  };
},
methods: {
}
};
</script>

<style>
.expand-collapse {
  color: #1F6FFF;
}
</style>
